import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config";
import styles from "./topservices.module.css";

const TopServices = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const featuresRef = ref(dimaniwasRtdb, "features");

    const unsubscribe = onValue(featuresRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadedFeatures = Object.keys(data).map((key) => ({
          id: key,
          ...data[key]
        }));
        setFeatures(loadedFeatures);
      } else {
        setFeatures([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <section className={styles.campsiteSection}>
      <div className={styles.campsiteHeader}>
        <h2 className={styles.campsiteTitle}>Our Main Attractions</h2>
        <div className={styles.campsiteTitleUnderline}></div>
        <p className={styles.campsiteSubtitle}>
          Camping, lakeside dining, water activities & boating you’ll love.
        </p>
      </div>

      {loading ? (
        <div className={styles.loaderWrapper}>
          <div className={styles.spinner}></div>
          <p>Loading attractions...</p>
        </div>
      ) : (
        <div className={styles.campsiteGrid}>
          {features.map((feature) => (
            <div key={feature.id} className={styles.campsiteCard}>
              <div className={styles.campsiteImageWrapper}>
                <img
                  src={feature.image}
                  alt={feature.title}
                  className={styles.campsiteImage}
                />
                <div className={styles.campsiteGradientOverlay}></div>
                
                <div className={styles.campsiteCardContent}>
                  <h3 className={styles.campsitePackageTitle}>
                    {feature.title}
                  </h3>
                  <div className={styles.campsiteExploreBtn}>
                    <span>Explore</span>
                    <span className={styles.arrowIcon}>→</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default TopServices;
